import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsThisFor() {
  return <section className="w-full bg-[#0F1B2D] text-[#FAFAF5] py-24 px-6 md:px-12" data-id="element-194">
      <div className="max-w-6xl mx-auto" data-id="element-195">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-196">
          {/* Left Column - FOR YOU */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-197">
            <h3 className="text-2xl font-bold text-green-400 flex items-center gap-3" data-id="element-198">
              <CheckCircle2 className="w-8 h-8" data-id="element-199" />
              This is for you if...
            </h3>
            <ul className="space-y-6" data-id="element-200">
              {['You want side income without going back to school', 'You can film with a phone', 'You want a clear niche and clear scripts', "You can commit to one small daily action (even if you're nervous)"].map((item, i) => <li key={i} className="flex items-start gap-4 text-lg text-gray-200" data-id="element-201">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-202" />
                  <span data-id="element-203">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right Column - NOT FOR YOU */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-8 md:border-l md:border-gray-800 md:pl-12" data-id="element-204">
            <h3 className="text-2xl font-bold text-red-400 flex items-center gap-3" data-id="element-205">
              <XCircle className="w-8 h-8" data-id="element-206" />
              This is NOT for you if...
            </h3>
            <ul className="space-y-6" data-id="element-207">
              {['You want guaranteed money without sending messages', 'You refuse to be on camera in any form (hands/voiceover is fine)', "You want a 'get rich' fantasy instead of a real system"].map((item, i) => <li key={i} className="flex items-start gap-4 text-lg text-gray-400" data-id="element-208">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-209" />
                  <span data-id="element-210">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}